export const changeAccountImage = `<svg width="32" height="32" viewBox="0 3 32 32" xmlns="http://www.w3.org/2000/svg">
<g fill="none" fill-rule="evenodd">
    <g>
        <path d="M0 0h32v32H0z"/>
        <circle stroke="#000" stroke-width="2" cx="11" cy="13.5" r="6.5"/>
        <path d="M19.427 7.242A6.5 6.5 0 1 1 21.19 20M2 24.675a11.002 11.002 0 0 1 18-.001M21.19 20a10.987 10.987 0 0 1 9 4.674" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <path d="M0 0h32v32H0z"/>
    <path d="M19.427 7.242A6.5 6.5 0 1 1 21.19 20m0 0a10.987 10.987 0 0 1 9 4.674" stroke="var(--theme-primary, #810ea9)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>`;

export const openIcon = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="M18.684 6.909c.566-.584 1.442-.537 1.956.105.475.593.476 1.486.028 2.079l-.121.141-7.616 7.857c-.484.5-1.202.541-1.725.125l-.137-.125-7.616-7.857c-.566-.584-.607-1.577-.093-2.22.475-.592 1.258-.678 1.82-.229l.136.124 6.683 6.897 6.685-6.897z" fill="var(--theme-primary, #810ea9)" fill-rule="nonzero"/>
</svg>`;

export const closeIcon = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="M5.316 17.091c-.566.584-1.442.537-1.956-.105-.475-.593-.476-1.486-.028-2.079l.121-.141 7.616-7.857c.484-.5 1.202-.541 1.725-.125l.137.125 7.616 7.857c.566.584.607 1.577.093 2.22-.475.592-1.258.678-1.82.229l-.136-.124-6.683-6.897-6.685 6.897z" fill="var(--theme-primary, #810ea9)" fill-rule="nonzero"/>
</svg>`;
